import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import toast from "react-hot-toast";
import { bulkUnEnrollTabByExcel, UnEnrolltab } from "services/unenrollment"; // <-- new API service
import * as XLSX from "xlsx";
import excelFile from "assets/excels/bulkunenrollment.xlsx";
import useCookie from "hooks/useCookie";
import { encryptData } from "config/config";
import DeleteIcon from "@mui/icons-material/Delete";

export default function BulkUnEnrollmentPage() {
    const [file, setFile] = useState(null);
    const [result, setResult] = useState(null);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const { cookies } = useCookie();

    // handle file change
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // handle upload
    const handleUpload = async () => {
        if (!file) {
            toast.error("Please choose an Excel file first");
            return;
        }

        try {
            showLoader();
            const formData = new FormData();
            formData.append("excel", file);
            formData.append(
                "reqData",
                encryptData({
                    access_token: cookies,
                })
            );

            const res = await bulkUnEnrollTabByExcel(formData);

            hideLoader();
            if (res.code === 200) {
                toast.success(res.message);
                setResult(res.data);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    const handleUnenroll = async (row) => {
        try {
            const res = await UnEnrolltab({
                imeanumber: row.imeanumber,   // use the selected row
                studentid: row.studentid,     // backend needs this
            });
            if (res.code === 200) {
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };


    return (
        <div className="WrapperBox">
            <div className="Small-Wrapper">
                <h4 className="Title mb-3">Bulk Tab UnEnrollment</h4>

                {/* File upload */}
                {/* File upload */}
                <div className="d-flex gap-2 mb-4">
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        className="form-control"
                        style={{ maxWidth: "600px" }}   // 👈 limit width
                    />
                    <Button onClick={handleUpload}>Upload & Process</Button>
                    <Button
                        className="mx-2"
                        onClick={() => window.open(excelFile)}
                    >
                        Download Sample
                    </Button>
                </div>


                {loader}

                {/* Show results */}
                {result && (
                    <>

                        <h5 className="mb-2">❌ Failed Records</h5>
                        <div className="TableList overflow-auto table-responsive">
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Email</th>
                                        <th>IMEA Number</th>
                                        <th>Reason</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result.failed && result.failed.length > 0 ? (
                                        result.failed.map((row, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{row.emailid}</td>
                                                <td>{row.imeanumber}</td>
                                                <td className="text-danger">{row.reason}</td>
                                                <td>

                                                    <button
                                                        type="acl"
                                                        className="flex items-center gap-1 text-red-600 hover:text-red-800"
                                                        onClick={() => handleUnenroll(row)}
                                                    >
                                                        <DeleteIcon className="w-5 h-5" />
                                                        <span>UnEnroll</span>
                                                    </button>

                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <NotFound cols={4} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
